import React from 'react';
import HomeContent from '../containers/HomePega/ContentMedia';
import NotFoundPage from '../containers/NotFoundPage';
import Sport from '../components/Sports/Sport';

import AccountVip from '../containers/AccountVip/AccountVip';
import ListVideo from '../containers/Video/ListVideo';

import DetailMediaPage from '../containers/DetailMediaPage/DetailMedia';
import LiveTV from '../containers/LiveTV/LiveTV';
import MoviesPageContent from '../containers/MoviesPage/MoviesPageContent';

import CategoryPageMovies from '../containers/MoviesPage/CategoryPageMovies';
import AllShow from '../containers/TVShow/AllShow';
import ShowCategoryItems from '../containers/TVShow/ShowCategoryItems';

import SportCate from '../components/Sports/SportCate';
import FilterPageMovies from '../containers/MoviesPage/FilterPageMovies';

import GetSinglePage from '../containers/GetSinglePage';
import Scoin from '../components/Scoin/Scoin';
import Histories from '../components/Scoin/Histories';
import PurchaseDay from '../containers/Scoin/PurchaseDay';
import Packages from '../containers/Scoin/Packages';
import PackageDetail from '../containers/Scoin/PackageDetail';

import User from '../containers/Users/User';
import PurchasedPackage from '../components/Scoin/PurchasedPackage';
import Login from '../components/MainPanel/Login';

const routes = [
    {
        path: '/',
        exact: true,
        main: () => <HomeContent />
    },
    {
        path: '/the-thao',
        exact: true,
        main: () => <Sport />
    },
    {
        path: '/the-thao/:path/:id',
        exact: true,
        main: (props) => <SportCate match={props.match} props={props} {...props} />
    },
    {
        path: '/the-thao/:slug/watch/:id_media',
        exact: true,
        main: (props) => {
            return <DetailMediaPage match={props.match} props={props} {...props} />
        }
    },
    {
        path: '/account-vip',
        exact: false,
        main: () => <AccountVip />
    },
    {
        path: '/list_video',
        exact: false,
        main: () => <ListVideo />
    },
    {
        path: '/media/watch/:id_media/:id_ep',
        exact: true,
        main: (props) => {
            return <DetailMediaPage match={props.match} props={props} {...props} />
        }
    },
    {
        path: '/livetv/:channel_slug?',
        exact: true,
        main: (props) => {
            return <LiveTV props={props} {...props} />
        }
    },
    {
        path: '/trang-phim',
        exact: true,
        main: () => <MoviesPageContent />
    },
    {
        path: '/:media/watch/:id_media/',
        exact: true,
        main: (props) => {
            return <DetailMediaPage match={props.match} props={props} {...props} />
        }
    },
    {
        path: '/trang-phim/:_id/:slug',
        exact: true,
        main: ({ match }) => <CategoryPageMovies match={match} />
    },
    {
        path: '/trang-phim/filter',
        exact: false,
        main: ({ match, location }) => <FilterPageMovies match={match} location={location} />
    },
    {
        path: '/tvshow',
        exact: true,
        main: () => <AllShow />
    },
    {
        path: '/singlepage/:slug',
        exact: true,
        main: (props) => <GetSinglePage props={props} {...props} />
    },
    {
        path: '/tvshow/:category_id',
        exact: true,
        main: (props) => {
            return <ShowCategoryItems props={props} {...props} />
        }

    },
    {
        path: '/scoin',
        exact: true,
        main: (props) => {
            return <Scoin />
        }
    },
    {
        path: '/purchase-day',
        exact: true,
        main: (props) => {
            return <PurchaseDay />
        }
    },
    {
        path: '/histories',
        exact: true,
        main: (props) => {
            return <Histories />
        }
    },
    {
        path: '/packages',
        exact: true,
        main: (props) => {
            return <Packages />
        }
    },
    {
        path: '/package-detail/:id',
        exact: true,
        main: (props) => {
            return <PackageDetail props={props} {...props} />
        }
    },
    {
        path: '/purchased-package/:package_id/:package_detail_id',
        exact: true,
        main: (props) => {
            return <PurchasedPackage props={props} {...props} />
        }
    },
    {
        path: '/profile/:id',
        exact: true,
        main: (props) => {
            return <User {...props} />
        }
    },
    {
        path: '/login',
        exact: true,
        main: (props) => {
            return <Login />
        }
    },
    {
        path: '',
        exact: false,
        main: () => <NotFoundPage />
    },
];
export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js